import { alpha, styled } from '@mui/material/styles';

// ----------------------------------------------------------------------

// The brand accent rule that sits to the left of every page heading — a
// quiet premium signature that reads consistently across the dashboard.
// Shared by HeaderBreadcrumbs (list pages) and PageBackHeader (detail/flow
// pages) so the heading unit looks identical everywhere.
const AccentRule = styled('span')(({ theme }) => ({
  display: 'block',
  width: 4,
  height: 38,
  borderRadius: 999,
  flexShrink: 0,
  background: `linear-gradient(180deg, ${theme.palette.primary.light}, ${theme.palette.primary.main})`,
  boxShadow: `0 4px 12px -2px ${alpha(theme.palette.primary.main, 0.5)}`,
}));

export default AccentRule;
